import React, { useState } from "react";
import { IGGCargoMachinListCom } from "./CargoMachinaryDetails/IGGCargoMachinList";
import { BWTCargoMachinListCom } from "./CargoMachinaryDetails/BwtsCargoMachinList";
import { CargoCraneListCom } from "./CargoMachinaryDetails/CargoCranList";
import { LpgCargoListCom } from "./CargoMachinaryDetails/LpgCargoList";
import { LngCargoCompressorListCom } from "./CargoMachinaryDetails/LngCargoCompressureList";
import { NitrogenPlantListCom } from "./CargoMachinaryDetails/NitrogenPlantList";
import { CoptListCom } from "./CargoMachinaryDetails/CoptList";
import { FramoListCom } from "./CargoMachinaryDetails/FramoList";
import Remark from "./CargoMachinaryDetails/Remark";

export const CargoMachineryTabCom = ({ id }) => {
  const [activeTab, setActiveTab] = useState("BWTS");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "BWTS" ? "active" : ""}
            onClick={() => handleClick("BWTS")}
          >
            BWTS
          </li>
          <li
            className={activeTab === "IGG" ? "active" : ""}
            onClick={() => handleClick("IGG")}
          >
            IGG
          </li>

          <li
            className={activeTab === "CargoCrane" ? "active" : ""}
            onClick={() => handleClick("CargoCrane")}
          >
            Cargo Crane
          </li>
          <li
            className={activeTab === "LpgCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LpgCargoCompressor")}
          >
            LPG Cargo Compressor
          </li>
          <li
            className={activeTab === "LngCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LngCargoCompressor")}
          >
            LNG Cargo Compressor
          </li>
          <li
            className={activeTab === "NitrogenPlant" ? "active" : ""}
            onClick={() => handleClick("NitrogenPlant")}
          >
            Nitrogen Plant
          </li>

          <li
            className={activeTab === "Copt" ? "active" : ""}
            onClick={() => handleClick("Copt")}
          >
            Copt
          </li>
          <li
            className={activeTab === "Framo" ? "active" : ""}
            onClick={() => handleClick("Framo")}
          >
            Framo
          </li>
          <li
            className={activeTab === "Remark" ? "active" : ""}
            onClick={() => handleClick("Remark")}
          >
            Remark
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "BWTS" && <BWTCargoMachinListCom id={id} />}
        {activeTab == "IGG" && <IGGCargoMachinListCom id={id} />}
        {activeTab == "CargoCrane" && <CargoCraneListCom id={id} />}
        {activeTab == "LpgCargoCompressor" && <LpgCargoListCom id={id} />}
        {activeTab == "LngCargoCompressor" && (
          <LngCargoCompressorListCom id={id} />
        )}
        {activeTab == "NitrogenPlant" && <NitrogenPlantListCom id={id} />}
        {activeTab == "Copt" && <CoptListCom id={id} />}
        {activeTab == "Framo" && <FramoListCom id={id} />}
        {activeTab == "Remark" && <Remark id={id} />}
      </div>
    </>
  );
};
